import React, { useRef, useState } from "react";
// 从 react-bootstrap 导入 UI 组件
import { Form, Button, Card, Alert } from "react-bootstrap";
// 使用自定义认证上下文 Hook 获取登录方法和当前用户
import { useAuth } from "../../contexts/AuthContext";
// 从 react-router-dom 导入 Link 和 useNavigate，用于页面导航
import { Link, useNavigate } from "react-router-dom";
// 导入 Bootstrap 样式
import "./Form.css";
import "bootstrap/dist/css/bootstrap.min.css";

const Login = () => {
  // 创建引用，用于获取输入框的值
  const emailRef = useRef();
  const passwordRef = useRef();

  // 从认证上下文中提取 login 方法和当前登录用户信息
  const { login, loginWithGoogle, loginWithFacebook, loginWithMicrosoft,  currentUser } = useAuth();

  // 定义 state 用于存储错误信息和加载状态
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  // 获取 useNavigate 实例，用于程序导航
  const navigate = useNavigate();

  // 处理登录表单提交的异步函数
  const handleSubmit = async (e) => {
    // 阻止表单的默认提交行为
    e.preventDefault();
    // 重置错误信息
    setError("");
    // 设置加载状态为 true，禁用表单按钮
    setLoading(true);

    try {
      // 调用 login 方法，传入邮箱和密码
      await login(emailRef.current.value, passwordRef.current.value);
      // 登录成功后导航至首页
      navigate("/");
    } catch (err) {
      // 控制台打印错误信息
      console.error(err);
      // 更新错误信息，告知用户登录失败
      setError("Failed to sign in, maybe need verify your email");
    } finally {
      // 无论成功或失败，都关闭加载状态
      setLoading(false);
    }
  };
  // Google 登录
  const handleGoogleLogin = async () => {
    try {
      setError("");
      setLoading(true);
      await loginWithGoogle();
      navigate("/");
    } catch (err) {
      console.error(err);
      setError("Failed to sign in with Google");
    } finally {
      setLoading(false);
    }
  };
    // Facebook 登录
    const handleFacebookLogin = async () => {
      try {
        setError("");
        setLoading(true);
        await loginWithFacebook();
        navigate("/");
      } catch (err) {
        console.error(err);
        setError("Failed to sign in with Facebook");
      } finally {
        setLoading(false);
      }
    };

      // Microsoft 登录
  const handleMicrosoftLogin = async () => {
    try {
      setError("");
      setLoading(true);
      await loginWithMicrosoft();
      navigate("/");
    } catch (err) {
      console.error(err);
      setError("Failed to sign in with Microsoft");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="form-container">
      {/* 使用 Card 组件构建登录表单的容器 */}
      <Card>
        <Card.Body>
          {/* 页面标题 */}
          <h2 className="text-center mb-4">Log In</h2>
          {/* 如果当前用户存在，显示其邮箱（仅用于展示） */}
          {currentUser && (
            <div className="text-center mb-3">{currentUser.email}</div>
          )}
          {/* 显示错误提示信息 */}
          {error && <Alert variant="danger">{error}</Alert>}
          {/* 登录表单 */}
          <Form onSubmit={handleSubmit}>
            {/* 邮箱输入组 */}
            <Form.Group id="email">
              <Form.Label>Email</Form.Label>
              <Form.Control
                type="email"
                ref={emailRef}
                required
                placeholder="Enter your email"
              />
            </Form.Group>
            {/* 密码输入组 */}
            <Form.Group id="password" className="mt-3">
              <Form.Label>Password</Form.Label>
              <Form.Control
                type="password"
                ref={passwordRef}
                required
                placeholder="Enter your password"
              />
            </Form.Group>
            {/* 提交按钮，根据 loading 状态显示不同文本 */}
            <Button disabled={loading} className="w-100 mt-3" type="submit">
              {loading ? "Signing In..." : "Log In"}
            </Button>
          </Form>
          <hr />
          <div className="text-center">
            <p>Or log in with:</p>
            <Button className="w-100 mb-2" onClick={handleGoogleLogin}>
              Log In with Google
            </Button>
            <Button className="w-100 mb-2" onClick={handleFacebookLogin}>
              Log In with Facebook
            </Button>
            <Button className="w-100" onClick={handleMicrosoftLogin}>
              Log In with Microsoft
            </Button>
          </div>
          {/* 导航链接：忘记密码及返回主页 */}
          <div className="w-100 text-center mt-3">
            <Link to="/forgot-password">Forgot Password?</Link>
            <br />
            <Link to="/">Go to Homepage</Link>
          </div>
        </Card.Body>
      </Card>
      {/* 注册页面链接：适用于尚未拥有账户的用户 */}
      <div className="w-100 text-center mt-2">
        Need an account? <Link to="/signup">Sign Up</Link>
      </div>
    </div>
  );
};

export default Login;